module.exports = __webpack_public_path__ + "img/success-case.cc53f0e8.png";